// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___L23_W"};